<template>
    <div class="home">
        <v-row justify="center">
            <v-col cols="12" md="7" lg="7">
                <v-card>
                    <div class="title text-center font-weight-light pa-5">
                        <span>
                            Приложение позволит автоматизировать процесс продаж в
                            интернет-магазинах работающих в мессенджерах Telegram, WhatsApp, Вконтакте:
                        </span>
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6" v-for="item in items">
                                <v-row justify="center">
                                    <v-icon large>
                                        {{item.icon}}
                                    </v-icon>
                                </v-row>
                                <span class="font-weight-light subtitle-2 black--text">
                                    {{item.text}}
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'Home',
    data () {
        return {
            items: [
                {
                    icon: 'mail_outline',
                    text: 'Создавайте рассылки по отдельным группам, или выбранной аудитории подписчиков в группе,\n' +
                          'автосообщения для "подогрева" клиентов. Создавайте туннели и воронки продаж прямо в\n' +
                          'чате вашей группы!'
                },
                {
                    icon: 'settings_input_component',
                    text: 'Подключайте сторонние сервисы по управлению потока клиентов: "AmoCRM" и складского\n' +
                          'учета товаров "Мой Склад" и показывайте клиентам актуальную информацию из склада:\n' +
                          'наличие размеров и остатка'
                },
                {
                    icon: 'trending_up',
                    text: 'Используйте внутренние модули по массовому изменению цены и описания товаров'
                },
                {
                    icon: 'widgets',
                    text: 'Заказывайте модули по автоматизации для своего бизнеса и мы внедрим их'
                }
            ]
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
